module.exports = __webpack_public_path__ + "668cbbf717a46e8f2262bc69d8023c08.png";